import {WBIcon} from '@wandb/ui';
import {RED_500, RED_550} from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
import styled from 'styled-components';

export const RetryTargetBlank = styled(TargetBlank)`
  display: flex;
  align-items: center;
  color: ${RED_500};
  font-weight: 800;
  &:hover {
    color: ${RED_550};
  }
`;

export const AccountWarningMessages = styled.div`
  > div {
    margin-bottom: 5px;
  }
`;

export const AddPayment = styled(WBIcon)`
  margin-left: 1px;
`;
